"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Paragraph = _interopRequireDefault(require("@rsuite/icon-font/lib/file/Paragraph"));

// Generated by script, don't edit it please.
var Paragraph = (0, _createSvgIcon["default"])({
  as: _Paragraph["default"],
  ariaLabel: 'paragraph',
  category: 'file',
  displayName: 'Paragraph'
});
var _default = Paragraph;
exports["default"] = _default;
module.exports = exports.default;